import { useSelector } from "react-redux";
import { AbsoluteCenter, Box, Flex, Image, Text } from "@chakra-ui/react";
import Balance from "../Balance/Balance";
import useCheckLogin from "../../hook/useCheckLogin";
import ClearCashRegisterButton from "../ClearCash/ClearCashRegisterButton";
import BetRecordButton from "../BetRecordButton/BetRecordButton";
import MusicToggleButton from "./HeaderComponents/MusicToggleButton";
import ReloadButton from "./HeaderComponents/ReloadButton";
import { COMMON_WEB_PATH } from "../../constant";

const HeaderBottom = () => {
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const memberInfo = useSelector((state) => state.isMemberInfo);

  const gradientStyle = {
    color: "white",
    WebkitTextStroke: "1px #804ed2",
    textStroke: "1px #804ed2",
    textShadow: `
    -1px -1px 0 #804ed2,  
     1px -1px 0 #804ed2,
    -1px 1px 0 #804ed2,
     1px 1px 0 #804ed2
  `,

    display: "inline-block",
  };

  return (
    <Box
      width={{
        base: `100%`,
        xl: `100%`,
      }}
      minHeight={{
        base: isMachineDomain || isMachineUser ? "115px" : "70px",
        sm: isMachineDomain || isMachineUser ? "115px" : "70px",
        md: "125px",
        xl: "150px",
      }}
      position="fixed"
      mx="auto"
      bottom="0px"
      bgImage={{
        base: `url(${COMMON_WEB_PATH}/now888/header/landscape_machine_header_bg_.png)`,
        lg:
          isMachineDomain || isMachineUser
            ? `url(${COMMON_WEB_PATH}/now888/header/landscape_machine_header_bg_.png)`
            : `url(${COMMON_WEB_PATH}/now888/header/landscape_machine_header_bg_.png)`,
      }}
      bgSize="105% 100%"
      zIndex={{
        base: "999",
        sm: "1001",
      }}
      borderBottomLeftRadius={{
        base: "none",
        lg: "15px",
      }}
      borderBottomRightRadius={{
        base: "none",
        lg: "15px",
      }}
      display="flex"
      pt={{
        base: "0px",
        xl: isMachineUser || isMachineDomain ? "20px" : "0px",
      }}
      alignItems={"center"}
      justifyContent="space-between"
      pr={{
        base: "1%",
        md: "1%",
        lg: "1%",
        xl: "5%",
      }}
      pl={{
        base: isLogin ? "1%" : "3%",
        md: isLogin ? "1%" : "3%",
        lg: isMachineDomain || isMachineUser ? "1%" : "6%",
        xl: isMachineDomain || isMachineUser ? "1%" : "8%",
      }}
      transition="all 0.3s ease" // 過渡
      sx={{
        backgroundPositionX: "-15px",
      }}
    >
      <Flex
        alignItems={{
          base: "center",
          md: "center",
        }}
        pt={{
          base: "5px",
          md: "unset",
        }}
        justifyContent={{
          base: "flex-end",
          sm: "space-between",
        }}
        pl={{
          md: "0px",
          base: "0px",
          // lg: isGameBox ? "0px" : "245px",
        }}
        pr={{
          md: "0px",
          base: "0px",
        }}
        pb={{
          base: "0px",
          sm: "0px",
        }}
        width="100%"
        height="100%"
      >
        <Flex w="16%" direction={"column"}>
          <Flex gap="5px">
            {/* 重整按鈕 */}
            <ReloadButton />
            {/* 音樂按鈕 */}
            <MusicToggleButton />
          </Flex>
          <Flex gap="30px">
            <Flex
              //w="auto"
              minW="100px"
              px="10px"
              gap="8px"
              height={"40px"}
              bgImage={`url('${COMMON_WEB_PATH}/now888/header/uid_banner.png')`}
              bgPosition="center"
              bgRepeat="no-repeat"
              bgSize="100%100%"
              alignItems={"center"}
              justifyContent={"center"}
              shadow="sm"
            >
              <Text
                color="transparent"
                sx={gradientStyle}
                fontSize={{
                  base: "xl",
                  //xl: "2xl",
                  xl: isMachineUser ? "30px" : "30px",
                }}
                fontWeight="900"
              >
                NO.{memberInfo?.uid || "-"}
              </Text>
            </Flex>
          </Flex>
        </Flex>
        {/* <AbsoluteCenter left="32.5%" top="45%"> */}
        <Box
          w="37%"
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          {/* <Image
            w={{
              base: "200px",
              md: "240px",
            }}
            src={`${COMMON_WEB_PATH}/now888/machine_logo_.png`}
          /> */}
        </Box>
        {/* </AbsoluteCenter> */}
        <Flex
          flex={1}
          justifyContent={"flex-end"}
          gap="10px"
          alignItems={"center"}
        >
          {/* 餘額 */}
          <Flex gap="10px">
            {/* 棄分按鈕 */}
            {/* <ClearCashRegisterButton /> */}
            {/* 投注記錄 */}
            <BetRecordButton />
          </Flex>
          <Balance />
        </Flex>
      </Flex>
    </Box>
  );
};

export default HeaderBottom;
